export const formatCurrencyForDisplay = centsInteger => `$${(centsInteger / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;